import { render } from "./NewMarketing.vue?vue&type=template&id=632a49b0&scoped=true"
import script from "./NewMarketing.vue?vue&type=script&lang=js"
export * from "./NewMarketing.vue?vue&type=script&lang=js"

import "./NewMarketing.vue?vue&type=style&index=0&id=632a49b0&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632a49b0"]])

export default __exports__